import AxiosService from './AxiosService'

class KeyManagementRestService {
  getVisibleKeys(): Promise<any> {
    return AxiosService.get('/keys/visible')
  }

  hideLegacyKey(keyId: string, version: number): Promise<any> {
    return AxiosService.put(`/keys/legacy/${keyId}/${version}`)
  }

  hideHsmKey(keyId: string, version: number): Promise<any> {
    return AxiosService.put(`/keys/hsm/${keyId}/${version}`)
  }

  editLunaHsmKey(key: any): Promise<any> {
    return AxiosService.put(`/keys/luna/${key.keyId}/${key.keyVersion}`, key)
  }

  editUtimacoHsmKey(key: any): Promise<any> {
    return AxiosService.put(`/keys/utimaco/${key.keyId}/${key.keyVersion}`, key)
  }

  getKeyRotation(): Promise<any> {
    return AxiosService.get('/keys/keyrotation')
  }

  changeKeyRotation(keyRotationSetting: any): Promise<any> {
    return AxiosService.put('/keys/keyrotation', null, {
      params: {
        ...keyRotationSetting,
      },
    })
  }

  createLunaHsmKey(key: any): Promise<any> {
    return AxiosService.post('/keys/luna/', key)
  }

  createUtimacoHsmKey(key: any): Promise<any> {
    return AxiosService.post('/keys/utimaco', key)
  }

  createRandomKeys(): Promise<any> {
    return AxiosService.post('/keys/randomkeys')
  }
}

export default new KeyManagementRestService()
